import { Injectable } from '@angular/core';

import { ToasterService } from '../modules/ui-components/toaster';
import { UserPermissionsService } from './user-permissions.service';

@Injectable({ providedIn: 'root' })
export class AccountingAccessService {

  constructor(
    private readonly userPermissionsService: UserPermissionsService,
    private readonly toasterService: ToasterService,
  ) {}

  public isReadOnly(): boolean {
    return this.userPermissionsService.canViewAccounting()
      && !this.userPermissionsService.canEditAccounting();
  }

  public denyWriteAccess(): boolean {
    const denied = this.isReadOnly();
    if (denied) {
      this.toasterService.notify({type: 'error', message: 'COMMON.NO_ACCESS_ACCOUNTING'});
    }

    return denied;
  }
}
